import { useHttpQuery } from '@luminovo/data-stack';
import * as React from 'react';

export function useCustomFavicon(): void {
    const { data: assets } = useHttpQuery(
        'GET /organization/settings',
        {},
        {
            staleTime: Infinity,
        },
    );

    React.useEffect(() => {
        const favicon = assets?.image_assets.favicon;
        const link = document.querySelector<HTMLLinkElement>('link[rel=icon]');
        if (!link) {
            return;
        }
        link.href = favicon || '/favicon.svg';
    }, [assets]);
}
